// -- copyright
// OpenProject is a project management system.
// Copyright (C) 2012-2015 the OpenProject Foundation (OPF)
//
// This program is free software; you can redistribute it and/or
// modify it under the terms of the GNU General Public License version 3.
//
// OpenProject is a fork of ChiliProject, which is a fork of Redmine. The copyright follows:
// Copyright (C) 2006-2013 Jean-Philippe Lang
// Copyright (C) 2010-2013 the ChiliProject Team
//
// This program is free software; you can redistribute it and/or
// modify it under the terms of the GNU General Public License
// as published by the Free Software Foundation; either version 2
// of the License, or (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program; if not, write to the Free Software
// Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
//
// See doc/COPYRIGHT.rdoc for more details.
// ++

import {Component, Injector, Input, ChangeDetectorRef, ViewChild} from '@angular/core';
import {I18nService} from 'core-app/modules/common/i18n/i18n.service';
import {FieldDescriptor, GroupDescriptor} from 'core-components/work-packages/wp-single-view/wp-single-view.component';
import {WorkPackageResource} from 'core-app/modules/hal/resources/work-package-resource';
import {EditFormComponent} from "core-app/modules/fields/edit/edit-form/edit-form.component";
import { HttpClient } from '@angular/common/http';

import {HandlerCheckObserveService} from '../../components/HandlerCheckObserve.service'
import {NotificationsService} from 'core-app/modules/common/notifications/notifications.service';
import { CustomInputComponent } from '../custom-input/custom-input.component';

declare let layui: any
//判断3有没有被选中，选中就启用4 没有禁用4
@Component({
  selector: 'wp-attribute-group',
  styleUrls: ['./wp-attribute-group.sass'],
  templateUrl: './wp-attribute-group.template.html'
})
export class WorkPackageFormAttributeGroupComponent {
  @Input() public workPackage:WorkPackageResource;
  //group 渲染规则
  @Input() public group:GroupDescriptor;
  @Input() public groupimgdata:any;
  @Input() public signusername:any;
  @Input() public signuserzhu:any;
  @Input() public groupedFields: any
  @Input() public is_project_admin: any
  @Input() public canAssigntNext: any
  @ViewChild(CustomInputComponent, { static: false }) customInput: CustomInputComponent;
  //服务
  //Inspection detail选项卡中渲染的文本数组
  public textArr:any[] = [];
  public groupitem=0
  public dipslesignature = false
  public signatureImage:any
  public signloding:any
  public memberssignitem:any = []
  public customFieldGroupPrincipal:any = []
  public selectCustomFieldGroup:any = null
  public okselect:boolean = true
  public numer:any =[]
  public check = false
  public isDefoultSign =  false
  public currentUser:any = document.querySelector('meta[name=current_user]')
  public defaultSign:any
  public checlist:any = {
    // 'There is no objection to you proceeding with the work.': false,
    // 'Survey record has been taken': false,
    // 'The following deficiencies have been noted:': false,
    // 'Work reinspected, no objection to you proceeding.': false ,
    // 'Detail of deficiencies': false,
    // 'Not Ready':false,
    'Accept':false,
    'Reject':false,
    'Not Ready':false

  }
  public checkdiabale:any = {
    // 'There is no objection to you proceeding with the work.': false,
    // 'Survey record has been taken': false,
    // 'The following deficiencies have been noted:': false,
    // 'Work reinspected, no objection to you proceeding.': false ,
    // 'Detail of deficiencies': false,
    // 'Not Ready':false,
    'Accept':false,
    'Reject':false,
    'Not Ready':false
  }
  public checkdiabaleStr?:any;
  requestHeader: any = {
    'X-Authentication-Scheme': 'Session',
    'X-Requested-With': 'XMLHttpRequest'
  };
  public formData:any=[]
  // promise chain 用來保證需要序列化執行的非同步操作逐一完成
  private _sequentialQueue: Promise<any> = Promise.resolve();
  //API前缀
  apiPrefix: any = '/api/v3';
  public itemlabel = [
    // 'There is no objection to you proceeding with the work.',
    // 'Survey record has been taken',
    // 'The following deficiencies have been noted:',
    // 'Work reinspected, no objection to you proceeding.' ,
    // 'Detail of deficiencies',
    // 'Not Ready',
    'Accept',
    'Reject',
    'Not Ready'
  ]
  public text = {
    date: {
      startDate: this.I18n.t('js.label_no_start_date'),
      dueDate: this.I18n.t('js.label_no_due_date')
    },
  };
  public mustNotBeBlank = [
    'Document Reference',
    'Actual inspection/check Date',
    '(1) Location of Work',
    // '(2) Work to be inspected/surveyed',
    '(2) Date & Time',
    // '(3) Work Proposed after Approval of (1)',
    'works outlined in (1) above [have / have not]* been inspected and/or surveyed:',
    'Permission to carry out the works proposed in(3) above is  [given / not given]* for the following reason(s):'
   ]
   public PermissionAndWordk = [
     'works outlined in (1) above [have / have not]* been inspected and/or surveyed:',
    'Permission to carry out the works proposed in(3) above is  [given / not given]* for the following reason(s):'
   ]
  public RecurrenceArr = [
    {
      "href": "null",
      "title": "-"
    },
    {
      "href": "/api/v3/custom_options/12",
      "title": "Yes"
    },
    {
      "href": "/api/v3/custom_options/13",
        "title": "No"
    },
    {
      "href": "/api/v3/custom_options/14",
      "title": "NA"
    }
    ]
  public worksOutlinedArr = [
      {
        "href": "null",
        "title": "-"
      },
      {
        "href": "/api/v3/custom_options/15",
        "title": "have"
      },
      {
        "href": "/api/v3/custom_options/16",
        "title": "have not"
      }
      ]
  public PermissionArr = [
    {
      "href": "null",
      "title": "-"
    },
    {
      "href": "/api/v3/custom_options/17",
      "title": "given"
    },
    {
      "href": "/api/v3/custom_options/18",
        "title": "not given"
    },
    ]
   public selectedValue = ''
   public selectedValue1 = ''
   public selectedValue2 = ''
   public checkFun:any
   public recheckStatus:any[] = [
    {
      label:"Contractor's Signature",
      status:'Submitted'
    },
    {
      label:"Supervisor's delegate Signature",
      status:'Delegated',
    },
    {
      label:"Inspector's Signature",
      status:'Inspecting',
    },
    {
      label:"Inspector/Surveyor's Signature",
      status:'Inspected',
    },
    {
      label:'RE/IOW/SSOE Signature',
      status:'Contersigned',
    },
    {
      label:'RE/SIOW/SSOE Signature',
      status:'Contractor Signed',
    },
    { 
      label:"Contractor's final Signature",
      status:'Closed with disapproval',
    },
    { 
      label:"Contractor's final Signature",
      status:'Closed with approval',
    }

   ]
  // 单选框要特殊处理
   public checkRadio:any = [
    'Countersign required'
   ]
   public showRadio(label:any){
    return this.checkRadio.indexOf(label) > -1
   }
  public ngOnInit() {

    // //console.log(this.groupimgdata,'asdasdasdasdasdadasd')
    if(this.workPackage.id != 'new')this.get_custom_field_group_available_principal(this.group.name)
    if(this.workPackage.type.name != 'RISC' && this.workPackage.type.name != 'RISC(inspection)' && this.workPackage.type.name != 'RISC(E&M)') return
    this.loadDefault()
    this.group.members.forEach( (descriptor:any) => {
      this.checlist[descriptor.label.trim()] = this.workPackage[descriptor.name]
    }) 
    this.checkRELOWLS()
    this.checkFun = this.detailSet()
    
    // this.checkFun.pushList([0,1], [2,3,4])
    // this.checkFun.pushList([0], [2,3,4])
    // this.checkFun.pushList([2], [0,3,4])
    // this.checkFun.pushList([1], [3,4])
    // this.checkFun.pushList([3], [0,1,2,4])
    // this.checkFun.pushList([4], [0,1,2,3])

    this.checkFun.pushList([0], [1,2])
    this.checkFun.pushList([1], [0,2])
    this.checkFun.pushList([2], [0,1])
    this.checkFun.setCheckList()
    this.checkFun.run()
    this.group.members.forEach((res:any)=>{
       if(!res.field.writable) this.okselect = false
       if(res.label.indexOf('Signature')>=0 ){
         this.memberssignitem.push(res)
       }
      })
      if(!this.group.status.find( (item:any) => {
        return item.id == this.workPackage.status.id
      }) && !this.is_project_admin) {
        this.okselect = false
      }
      // if(this.workPackage.status.name == 'New'){
      //   this.okselect = true
      // }
      //判断Inspection 选项卡进行操作
      if(this.group.name == 'Inspection detail'){
        //创建新数组testArr
        this.group.members.forEach((item) =>{
          if(this.itemlabel.indexOf(item.label.trim()) != -1){
            this.textArr.push(item.label) //修改的四个选项卡的文字字段
          }
        })
      }
    this.group.members.forEach((item:any)=>{
      if(item.label.indexOf('Recurrence of non-conformities')>=0){
        this.selectedValue = item.field.value
      }
      if(item.label.indexOf('works outlined in (1) above [have / have not]* been inspected and/or surveyed')>=0){
        this.selectedValue1 = item.field.value
      }
      if(item.label.indexOf('Permission to carry out the works proposed in(3) above is  [given / not given]* for the following reason(s)')>=0){
        this.selectedValue2 = item.field.value
      }
      if(item.label.indexOf('Location of Work')>=0&&item.field.attribute.raw){
        this.getWorkAddress()
      
      }else if(item.label.indexOf('Location of Work')>=0){
        this.initAddressData()
      }
    })
    
  }
   public ngAfterViewInit(){
  
   }
   onCommentsBlur(descriptor: any) {
    const params: any = {
      lockVersion: this.workPackage.lockVersion,
      _links: {}
    };
    
    params[descriptor.name] = this.workPackage[descriptor.name];
  
    this.requefunckpost(params, `${window.location.origin}/api/v3/work_packages/${this.workPackage.id}/form`)
      .subscribe((data: any) => {
        params['lockVersion'] = data._embedded.payload.lockVersion;
        
        this.requefunckpatch(params, `${window.location.origin}/api/v3/work_packages/${this.workPackage.id}`)
          .subscribe((res: any) => {
            this.workPackage.lockVersion = res.lockVersion;
            this.workPackage.customDefaultSignValues = res.customDefaultSignValues;
            this.handlerCheck.eventBus.emit('workpackgeChange');
          });
      });
  }
   getWorkAddress(){
    this.http.get(`/api/v3/work_packages/${this.workPackage.id}`).subscribe((res: any) => {
      console.log(res,'data');
      let data = JSON.parse(res.customField7.raw)
      //console.log(data,'idArr')
      let two_new_ids = []
      if(data.two_ids.length>0){
        for (let index = 0; index < data.two_ids.length; index++) {
          const element = data.two_ids[index];
          if(Object.prototype.toString.call(element) === '[object Object]'&&element.is_up){
            two_new_ids.push(element.id)
          }else{
            two_new_ids.push(element)
          }
        }
      }
      const mergedArray = [...data.one_ids, ...two_new_ids, ...data.pile_no];
      //console.log(mergedArray,'mergedArray');
      const el:any = document.querySelector('.openproject-base--ui-view')
      if(el){
        el.addEventListener('click',()=>{
          this.showDialogIndex = null
        })
      }
      
      this.initAddressData().then(async (res:any)=>{
        for (let index = 0; index < mergedArray.length; index++) {
          const element = mergedArray[index];
          try {
            let response = null
            //console.log(index,'indexindexindex');
            
            if(data.one_other&&index>=data.one_ids.length ){
              response = await this.selectAddress(index+1,{input_type:'select',id:element},false);             
            }else{
              response = await this.selectAddress(index,{input_type:'select',id:element},false);
            }
            //console.log('调用接口',response);
          } catch (error) {
            console.error(`调用接口失败: ${element}`, error);
          }
        }
        // console.log(data,this.formData,'this.formData');
        if(data.hasOwnProperty('two_other')&&data.hasOwnProperty('one_other')){
          this.formData[mergedArray.length+1].inputValue = data.two_other;
        }else if (data.hasOwnProperty('two_other')){
          this.formData[mergedArray.length].inputValue = data.two_other;
        }
        if(data.hasOwnProperty('one_other')){
          this.formData[data.one_ids.length].inputValue = data.one_other;
        }
        console.log(this.formData,'this.formData122323');
        
        this.handlerCheck.eventBus.emit({ type: 'fromData', formData: this.formData })
      })
    })
   }
   ShowBackBtn(obj:any,selectCustomFieldGroup:any){
    if(this.workPackage.status.name == 'New'){
      return false
    }
    // console.log(obj.label,'selectData');
    let selectData = this.recheckStatus.find(item=>item.status.indexOf(this.workPackage.status.name)>=0)
    if(!selectData){
      return false
    }
    if(selectData.label.indexOf(obj.label)>=0&&this.groupimgdata[obj.name]&&this.isCurrentUserOrAdmin(selectCustomFieldGroup)){
      return true
    }else{
      return false
    }
   }
  // 是否是当前用户或者admin用户
  isCurrentUserOrAdmin(selectCustomFieldGroup:any){
    return this.currentUser.dataset.id == selectCustomFieldGroup||this.is_project_admin
  }
   onRecurrenceChange(event:any,type:any,name:string){
      // 获取选择的值
      const selectElement = event.target as HTMLSelectElement;
      const selectedValue = selectElement.value;
      const params:any = {
        lockVersion: this.workPackage.lockVersion,
        _links: {},
      }
      let str =''
      if(name == 'RecurrenceArr'){
        this.RecurrenceArr.forEach(item=>{
          if(selectedValue == item.title){
            str = item.href
          }
      })
      }else if (name == 'worksOutlinedArr'){
        this.worksOutlinedArr.forEach(item=>{
          if(selectedValue == item.title){
            str = item.href
          }
      })
      } else if (name == 'PermissionArr'){
        this.PermissionArr.forEach(item=>{
          if(selectedValue == item.title){
            str = item.href
          }
      })
      }
  
      //console.log(selectedValue,'typetypetypetypetype');
      params._links[type.name]= {
        href:str
      } 
      // 在这里处理选择变更的逻辑
      this.requefunckpost(params,`${window.location.origin}/api/v3/work_packages/${this.workPackage.id}/form`).subscribe((data:any)=>{
        // redata['lockVersion'];//当前最新版本号
        params['lockVersion'] = data._embedded.payload.lockVersion
          this.requefunckpatch(params,`${window.location.origin}/api/v3/work_packages/${this.workPackage.id}`).subscribe((res:any)=>{
            this.workPackage.lockVersion = res.lockVersion
            this.workPackage.customDefaultSignValues = res.customDefaultSignValues
            this.handlerCheck.eventBus.emit('workpackgeChange')
          })
      })
   }
  // 渲染select选择框
   isRecurrence(text:any,type:any){
    if(type == 1){
      return text.indexOf('Recurrence of non-conformities')>=0 
    } else if (type == 2){
        return  text.indexOf('works outlined in (1) above [have / have not]* been inspected and/or surveyed')>=0
    }else if (type == 3){
      return text.indexOf('Permission to carry out the works proposed in(3) above is  [given / not given]* for the following reason(s)')>=0
    }else{
      return text.indexOf('Recurrence of non-conformities')>=0 || text.indexOf('works outlined in (1) above [have / have not]* been inspected and/or surveyed')>=0 || text.indexOf('Permission to carry out the works proposed in(3) above is  [given / not given]* for the following reason(s)')>=0
    }
   }
  //渲染CheckBox选框判断
  ArrFn(descriptor:any){
    if(this.textArr.indexOf(descriptor.label)>-1){
      return true
    }else{
      return false
    }
    
  }
  loadDefault() {
    let sign = this.group.members.find( (item:any) => {
      return item.label.indexOf('Signature') !== -1
    })

    if(sign) {

      if(this.workPackage.customDefaultSignValues[sign!.name]){
     
        this.defaultSign =  `${window.location.origin}/api/v3/logical_docs/doc/${
          this.workPackage.customDefaultSignValues[sign!.name]
        }/stream`
         this.isDefoultSign = true
        
    
     
      } else {
        this.defaultSign = this.currentUser.dataset.sign_doc_id.length > 0 ? `${window.location.origin}/api/v3/logical_docs/doc/${
          this.currentUser.dataset.sign_doc_id
        }/stream`: false
        this.isDefoultSign = false
 
     
      }
    }
  }
  fieldName (arr:any, field:string){
    // for (let item of arr) {
    //   if (item[field]) {
    //     return item[field];
    //   }
    // }
    return arr[0]? arr[0][field]:''
  }
  initAddressData() {
    //console.log(this.workPackage.type.name,'this.workPackage.id')
    let params = this.workPackage.type.name
    return new Promise((resolve,reject)=>{
      this.http.get(`/api/v3/work_packages/lw_list/${params}`).subscribe((data: any) => {
        if(this.formData.length <= 0){
          const defaultData = {
            id:'',
            label:this.fieldName(data,'label'),
            value:'',
            setp:'one_ids',
            input_type:this.fieldName(data,'input_type'),
            options:data,
            inputValue: '',
            optionsValue:data
          }
          this.formData.push(defaultData)
            //console.log(this.formData, data,'formData')
          }
          resolve(true)
      });
    })
  }
  // 添加防抖工具函数
  private debounce(func: Function, wait: number) {
    let timeout: any;
    let pending: { resolve: any; reject: any } | null = null;
    return (...args: any[]) => {
      // 每次呼叫都取消前一次的 timer
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
      // 若有未完成的 promise，可以選擇拒絕或忽略；這裡先拒絕以讓呼叫端能夠得知
      if (pending) {
        try { pending.reject({ cancelled: true }); } catch (e) {}
        pending = null;
      }

      return new Promise((resolve, reject) => {
        pending = { resolve, reject };
        timeout = setTimeout(() => {
          // 執行傳入的 function，若是返回 promise 則等待它完成
          Promise.resolve(func.apply(this, args))
            .then((v: any) => {
              pending = null;
              resolve(v);
            })
            .catch((err: any) => {
              pending = null;
              reject(err);
            });
        }, wait);
      });
    };
  }

  // 將 Observable 轉為 Promise 的小工具（兼容不同 rxjs 版本）
  private observableToPromise(obs: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const sub = obs.subscribe(
        (res: any) => {
          try { sub.unsubscribe && sub.unsubscribe(); } catch(e) {}
          resolve(res);
        },
        (err: any) => {
          try { sub.unsubscribe && sub.unsubscribe(); } catch(e) {}
          reject(err);
        }
      );
    });
  }

  // 用於把非同步操作排成序列執行的簡單 queue
  private runSequential<T>(operation: () => Promise<T>): Promise<T> {
    const p = this._sequentialQueue.then(() => operation()).catch((err) => {
      // 若前一個失敗，仍嘗試執行當前操作（並讓 queue 繼續）
      return operation();
    });
    // 維持 chain，成功或錯誤都會讓下一個等待
    this._sequentialQueue = p.then(() => undefined, () => undefined);
    return p;
  }

  // getLocationItem(tag:any,index:any,pile:any){
  //   this.http.get(`/api/v3/work_packages/lw_items/${tag}`).subscribe((data: any) => {
  //     //console.log(pile,'dataabcd');
  //     let arr = data.map((item:any)=>{
  //       return {
  //         id:item.id,
  //         title:item.name,
  //         input_type:'pile_select',
  //         child:[]
  //       }
  //     })
  //     if(pile){
  //       this.formData[this.formData.length] = {
  //         pile_id: pile.id,
  //         label: 'pile no:',
  //         value: pile.value,
  //         input_type:'pile_select',
  //         options: arr,
  //         inputValue: '',
  //         optionsValue: arr
  //       }
  //     }else{
  //     this.formData[index+1] = {
  //       pile_id: '',
  //       label: 'pile no:',
  //       value: '',
  //       input_type:'pile_select',
  //       options: arr,
  //       inputValue: '',
  //       optionsValue: arr
  //     }
  //     }
  //     // this.formData[0].options = data
  //     // this.formData[0].optionsValue = data
  //   });
  // }

  // 修改 changeInput 方法
  private debouncedUpdateAddress = this.debounce((descriptor: any,index:any) => {
    return this.updataAddress(descriptor,'input',index);
  }, 300); // 300ms 的防抖延迟

  async changeInput(descriptor: any,index:any) {
    try {
      // 等待防抖及序列化的更新完成（失敗時忽略錯誤以避免阻塞 UI）
      await this.debouncedUpdateAddress(descriptor,index);
    } catch (e) {
      // 可以選擇在此處 log 或顯示錯誤，但不阻斷後續操作
      // console.warn('debounced update failed', e);
    }
  }

  showDialog(index:any,descriptor:any){
    //console.log(descriptor,'descriptor');
    
    if(descriptor.field.writable){
      this.showDialogIndex = index
    }
  }
  public showDialogIndex:any = null
  public setp = ''
  public fatherPileNo =''
  getStepData (option:any){
    return new Promise((resolve,reject)=>{
    fetch(`${window.location.origin}/api/v3/work_packages/lw_seconds/${option.id}`)
          .then(response => response.json())
          .then(data => {
            resolve(data)
          })
          .catch(error => {
            console.error('Error fetching data:', error)
            reject(false)
          });
    })
  }

  getPileNoData (tag:string){
    return new Promise((resolve,reject)=>{
      const pileNoTag = this.fatherPileNo ? this.fatherPileNo : tag
      fetch(`${window.location.origin}/api/v3/work_packages/lw_items/${pileNoTag}`)
          .then(response => response.json())
          .then(data => {
            const newData = data.map((item:any)=>{
              return {
                id:item.id,
                title:item.name
              }
            })
            resolve(newData)
          })
          .catch(error => {
            console.error('Error fetching data:', error)
            reject(false)
          });
    })
  }

 selectAddress(index: number,option:any,descriptor:any){
    // 获取当前选中选项的子选项
   return new Promise(async(resolve)=>{
      let selectedOption =null
      if(this.formData[index].input_type=='select'){
        this.formData[index].id = option.id
        selectedOption = this.formData[index].options.find((res: any) =>
          res.id == this.formData[index].id
        );
      }
      if(selectedOption.label){
        this.formData[index].label = selectedOption.label
      }
      //console.log(this.formData,option,selectedOption,index,option,'this.formData1');
      this.formData[index].value = selectedOption.title
      this.setp = this.formData[index].setp
      if(selectedOption.is_up){
        this.formData[index].is_up = selectedOption.is_up
      }
      if(this.formData[index].setp == 'one_ids'&&selectedOption.pile_no){
        this.fatherPileNo = selectedOption.pile_no
      }
      if(selectedOption.input_type){
      if(selectedOption.location_second_tag&&selectedOption.id){
       const data:any = await this.getStepData(selectedOption)
      this.setp = 'two_ids'
      if(selectedOption.input_type == 'select'){
        if(data.length > 0){
          this.formData[index+1] = {
            id: '',
            setp:this.setp,
            label:this.fieldName(selectedOption.child,'label')?this.fieldName(selectedOption.child,'label'):selectedOption.child_label,
            value: '',
            input_type:selectedOption.input_type,
            options: data || [] ,
            inputValue: '',
            optionsValue: data || []
          };
       }
      }else{
        let placeholder = 'Enter '
        for (let index = 0; index < this.formData.length; index++) {
          if(this.formData[index].setp =="one_ids"&&this.formData[index].value =='U-channel chainage'){
            //console.log('没劲了了了');
            placeholder = placeholder+ this.formData[index].value + '..'
            break
          }else if (this.formData[index].setp =="one_ids"&&this.formData[index].value=='Others'){
             placeholder = placeholder+ this.formData[index-1].value + '..'
             break
          }
          
        }
  
        this.formData[index+1] = {
          setp:'one_ids',
          id: '',
          label:this.fieldName(selectedOption.child,'label')?this.fieldName(selectedOption.child,'label'):selectedOption.child_label,
          value: '',
          input_type:'input',
          placeholder:placeholder,
          options: [],
          inputValue: '',
          optionsValue: []
        };
        this.formData[index+2] = {
          setp:this.setp,
          id: '',
          label:this.fieldName(data,'label')?this.fieldName(data,'label'):selectedOption.child_label,
          value: '',
          input_type:'select',
          options: data || [] ,
          inputValue: '',
          optionsValue: data || []
        };
      }
      }else if (selectedOption.location_item_tag){
      //console.log(this.formData,'this.formDatathis.formData');
      
      const data = await this.getPileNoData(selectedOption.location_item_tag)
      this.setp = 'three_ids'
       this.formData[index+1] = {
        setp:this.setp,
        id: '',
        label:this.fieldName(selectedOption.child,'label')?this.fieldName(selectedOption.child,'label'):selectedOption.child_label,
        value: '',
        input_type:selectedOption.input_type,
        options: data || [] ,
        inputValue: '',
        optionsValue: data || []
      };
      }else if (selectedOption.input_type=='input'){
        //console.log(selectedOption,'selectedOption.input_type221211212');
        this.formData[index+1] = {
          setp:this.setp,
          id: '',
          is_up:selectedOption.is_up,
          label:this.fieldName(selectedOption.child,'label')?this.fieldName(selectedOption.child,'label'):selectedOption.child_label,
          value: '',
          input_type:'input',
          options: [],
          placeholder:'Enter specific works...',
          inputValue: '',
          optionsValue: []
        };
      }else{
          
          this.formData[index+1] = {
          setp:this.setp,
          id: '',
          label:this.fieldName(selectedOption.child,'label')?this.fieldName(selectedOption.child,'label'):selectedOption.child_label,
          value: '',
          input_type:selectedOption.input_type,
          options: selectedOption.child || [] ,
          inputValue: '',
          optionsValue: selectedOption.child || []
        };
      }
    }
      this.showDialogIndex = -1  
      if(selectedOption.input_type == 'input' &&selectedOption.location_second_tag){
        this.formData = this.formData.slice(0,index+3)
      }else{
        this.formData = this.formData.slice(0,index+2)
      }
      if(descriptor){
        //console.log('没进来')
        this.updataAddress(descriptor,option.input_type)
      }
      resolve(true)
    })
    
    
  }
  showInput(writable:any,item:any,inputValue:any){
    if(writable){
      item.isShowInput = item.isShowInput ? false : true
      item.backinputValue = inputValue
    }
  }
  cancelInput(writable:any,item:any){
      item.isShowInput = false
      item.inputValue = item.backinputValue
  }
  // 將更新地址的請求序列化，保證前一個完成（或失敗）後才開始下一個
  updataAddress(descriptor:any,type:any,index?:any){
    return this.runSequential(() => this._updataAddressImpl(descriptor,type,index));
  }
  public logNumber:any = 0
  private async _updataAddressImpl(descriptor:any,type:any,index?:any){
    try{
      const params:any = {
        lockVersion: this.workPackage.lockVersion,
        _links: {},
      }
      params[descriptor.name] = {}
      let paramsdata:any = {
        one_ids:[],
        two_ids:[],
        pile_no:[],
        one_other:'',
        two_other:''
      }
       this.formData.forEach((item:any)=>{
        if(item.input_type== 'select' && item.id){
          if(item.setp == 'three_ids'){
            paramsdata.pile_no.push(item.id)
          }else{
            if(item.setp == 'one_ids'){
              if(item.is_up){
                paramsdata[`two_ids`].push({id:item.id,is_up:item.is_up})
              }else{
                paramsdata[`${item.setp}`].push(item.id)
              }
            }else{
              paramsdata[`${item.setp}`].push(item.id)
            }
          }
        }else if (item.input_type=='input'){
          if (item.setp == 'one_ids') {
            if(item.is_up){
              paramsdata.two_other = item.inputValue;
            }else{
              paramsdata.one_other = item.inputValue;
            }
            } else {
              paramsdata.two_other = item.inputValue;
            }
        }
       })
       if(!paramsdata.one_other){
          delete paramsdata.one_other
       }
       if(!paramsdata.two_other){
        delete paramsdata.two_other
       }
      params[descriptor.name]['raw'] = JSON.stringify(paramsdata)

      // post 表單以取得最新 lockVersion
      const postRes: any = await this.observableToPromise(this.requefunckpost(params,`${window.location.origin}/api/v3/work_packages/${this.workPackage.id}/form`));
      params['lockVersion'] = postRes._embedded.payload.lockVersion
      this.handlerCheck.eventBus.emit({ type: 'fromData', formData: this.formData })

      // patch 更新實際 work_package
      const patchRes: any = await this.observableToPromise(this.requefunckpatch(params,`${window.location.origin}/api/v3/work_packages/${this.workPackage.id}`));
     console.log(this.logNumber++,'logNumberlogNumber');
      this.workPackage.lockVersion = patchRes.lockVersion
      this.workPackage.customDefaultSignValues = patchRes.customDefaultSignValues
      if(type == 'input'){
        this.showSuccessNotification('update success');
        // index 可能為 undefined（呼叫者未提供）或超出範圍，先檢查再設值以避免錯誤
        if(typeof index === 'number' && this.formData && this.formData[index]){
          this.formData[index].isShowInput = false;
        } else {
          // 找不到對應的 formData 項時，不要拋錯；可記錄以方便除錯
          // console.warn(`updataAddress: formData[${index}] is undefined, cannot set isShowInput`);
        }
      }
      setTimeout(()=>{
        this.handlerCheck.eventBus.emit('workpackgeChange')
      },500)
      return patchRes;
    }catch(err){
      // 錯誤處理：通知使用者並重新拋出以便呼叫端知道失敗
      try{
        this.showErrorNotification('update failed', [err && err.message ? err.message : '']);
      }catch(e){/* ignore */}
      throw err;
    }
  }
  inputChange(index:any){
    this.formData[index].optionsValue = this.formData[index].options.filter((item:any)=>{
      return item.title.toLowerCase().indexOf(this.formData[index].inputValue.toLowerCase()) != -1
    })
    //console.log(this.formData,'this.formData[index]');
    
  }

  ValueContainerContentStyle(descriptor:any) {

      return {'border-color':(this.workPackage.id == 'new' || this.userquanx(descriptor.name)) || this.Tip() || !this.canAssigntNext ? '#e3e3e3':'rgba(6, 150, 215, 1)', 'cursor': this.workPackage.id == 'new'?'auto':'pointer'}

  
}
  checkRELOWLS() {
    let checkGround = this.groupedFields.find( (item:any) => {
      return item.name == 'Inspection detail'
    }).members
    //console.log(checkGround,'checkGround');
    
    this.check = checkGround.some( (res:any) => {
       return res.field.value === true
    })

  }
  ValueContainerContentIconStyle(descriptor:any,check?:any) {
      return {'background-color':(this.workPackage.id == 'new' || this.userquanx(descriptor.name)) || this.Tip() ||!this.canAssigntNext ? '#e3e3e3':'rgba(6, 150, 215, 1)', 'cursor': this.workPackage.id == 'new'?'auto':'pointer'}
  }

//INSPECTION DETAIL 选项卡中checkBox点击事件
  checkTrue($event:any){
    let that = this;

    let name =  this.numer.find( (item:any) => {
      return $event.target.id == item.id
    }).name //每次点击的文本
    this.checlist[name] = $event.target.checked
    //console.log(this.checlist[name]);
    
    this.checkFun.run()
    //绑定服务
    let redata:any = {lockVersion: this.workPackage.lockVersion, _links: {},}
    //当前选中选项卡
    let reid:any = $event.target.id
    //是否被选中
    redata[reid] = $event.target.checked
    this.requefunckpost(redata,`${window.location.origin}/api/v3/work_packages/${this.workPackage.id}/form`).subscribe((data:any)=>{
      // redata['lockVersion'];//当前最新版本号
      redata['lockVersion'] = data._embedded.payload.lockVersion
        this.requefunckpatch(redata,`${window.location.origin}/api/v3/work_packages/${this.workPackage.id}`).subscribe((res:any)=>{
          this.workPackage.lockVersion = res.lockVersion
          this.workPackage.customDefaultSignValues = res.customDefaultSignValues
          this.handlerCheck.eventBus.emit('workpackgeChange')
         
        })
    })
  }
  checkTrueRadio($event:any,name:any,value:any){
    //绑定服务
    let redata:any = {lockVersion: this.workPackage.lockVersion, _links: {},}
    //当前选中选项卡
    
    redata[name] = value
    this.requefunckpost(redata,`${window.location.origin}/api/v3/work_packages/${this.workPackage.id}/form`).subscribe((data:any)=>{
      // redata['lockVersion'];//当前最新版本号
      redata['lockVersion'] = data._embedded.payload.lockVersion
        this.requefunckpatch(redata,`${window.location.origin}/api/v3/work_packages/${this.workPackage.id}`).subscribe((res:any)=>{
          this.workPackage.lockVersion = res.lockVersion
          this.workPackage.customDefaultSignValues = res.customDefaultSignValues
          this.handlerCheck.eventBus.emit('workpackgeChange')
        })
    })
   
  }
  detailSet() {
    let list: (() => void)[] = []
    return {
      pushList: (trueList:Array<number>, disableList:Array<number>)=> {
        list.push( () => {
          let isCheck = true
          trueList.forEach( (index) => {
    
            isCheck = isCheck && this.checlist[this.itemlabel[index]]
          })
          if(isCheck) {
            disableList.forEach( (index) => {
              this.checkdiabale[this.itemlabel[index]] = true
            })
          }
        })
      },
      run:() =>{
        let name = ''
        let arr = []
        for (let key in this.checlist) {
          if (this.checlist.hasOwnProperty(key)) { // 检查属性是否是对象自身的属性（而不是从原型链继承的）
            //console.log(`${key}: ${this.checlist[key]}`);
            if(this.itemlabel.includes(key)){
              arr.push({key:key,value:this.checlist[key]})
           
            }
          }
        }
        for (let index = 0; index < arr.length; index++) {
            if(arr[index].value){
              name = arr[index].key
              break
            }
        }
        

        this.checkdiabaleStr = this.itemlabel.reduce<Record<string, boolean>>((prev, cur) => {
          
          if(cur==name || !name){
            prev[cur] = false
          }else{
            prev[cur] = true
          }
          return prev;
        }, {});
        //console.log(this.checkdiabale, 'label1');
        
        list.forEach( (item:any) => {
          
          item()
        })
      },
      setCheckList: () => {
        let checkGround = this.groupedFields.find( (item:any) => {
          return item.name == 'Inspection detail'
        }).members
        checkGround.forEach( (res:any) => {
            this.checlist[res.field.label] = res.field.value
        })
      }
    }
  }
  //动态添加id标识
  numerdata(descriptor:any){
    let index = this.numer.find((data:any) => {
      return data.id == descriptor.name
    });
    if(!index)this.numer.push({id:descriptor.name,name:descriptor.label})
    return descriptor.name
  }

  constructor(readonly I18n:I18nService,
              public wpeditForm:EditFormComponent,
              protected injector:Injector,
              private http: HttpClient,
              private changeDetectorRef:ChangeDetectorRef,
              public handlerCheck: HandlerCheckObserveService,
              private notificationsService: NotificationsService) {
  }

  public trackByName(_index:number, elem:{ name:string }) {
    return elem.name;
  }

  /**
   * Hide read-only fields, but only when in the create mode
   * @param {FieldDescriptor} field
   */
  public shouldHideField(descriptor:FieldDescriptor) {
    const field = descriptor.field || descriptor.fields![0];
    if(descriptor.label == 'Comments'){
      return true
    }
    return this.wpeditForm.editMode && !field.writable;
  }


  displaysign(index:any){
    this.groupitem = index
    //console.log(this.userquanx(this.group.members[index].name),this.group.members[index].name,this.Tip(),this.workPackage.id,this.canAssigntNext,'权限权限');
    
    if(this.workPackage.id == 'new'||this.workPackage[this.group.members[index].name] || this.userquanx(this.group.members[index].name) || this.Tip()||!this.canAssigntNext)return
    // this.dipslesignature = true
    this.handlerCheck.eventBus.emit('showDialog')
  }

  displaymodel(name:string){
    if(this.workPackage.type.name == "RISC" ||this.workPackage.type.name ==  "RISC(inspection)" ||this.workPackage.type.name ==  "RISC(E&M)"){
      return name.indexOf('Signature')<0 ? true : false
    }else{
      return true
    }    
  }
  locationofwork(name:string){
    return name.indexOf('Location of Work')>-1 ? true : false
  }
  recheck (type?:any){
    this.http.post(`/api/v3/work_packages/${this.workPackage.id}/recheck_status`,{
      status_id: Number(this.workPackage.status.id),
      is_reject: type? true : false
    },{
      withCredentials: true,
      headers: this.requestHeader
    }).subscribe((res:any)=>{
      console.log(res,'res');
      // this.handlerCheck.eventBus.emit('overViewTab')
      window.location.reload()
    })
  }
  isSign (index:any) {
    return !(this.workPackage.id == 'new'||this.workPackage[this.group.members[index].name] || this.userquanx(this.group.members[index].name) || this.Tip())
  }
  closeView(img:any){
    
    this.signatureImage = img
    
    if(!img) {
      this.dipslesignature = false 
      return
    }
  
    this.groupimgdata[this.group.members[this.groupitem].name] = img
    
    let blob = this.dataURLtoBlob(img)
    this.signloding = img ? this.groupitem : ''
    var files = new File([blob], 'drawComplete.png', { type: blob.type })
    let file = new FormData();
    file.append('file', files);
    file.append('prefix', 'risc');
    this.dipslesignature = false
    let projectId:any = document.querySelector('meta[name=current_project]')

    this.http.get(`/api/v3/work_packages/${this.workPackage.id}`).subscribe((worlpageres:any)=>{
      this.requefunckpost(file,`${this.apiPrefix}/projects/${projectId.dataset.projectId}/sign`).subscribe((imgdata:any)=>{
        let requedata:any = {lockVersion: worlpageres.lockVersion,_links: {}}
        
        // this.requefunckpost(requedata,`${this.apiPrefix}/work_packages/${this.workPackage.id}/form`).subscribe((data:any)=>{
          requedata[this.group.members[this.groupitem].name] = imgdata.doc_id

          this.requefunckpatch(requedata,`${this.apiPrefix}/work_packages/${this.workPackage.id}`).subscribe((res:any)=>{
              this.workPackage[this.group.members[this.groupitem].name] = res[this.group.members[this.groupitem].name]
              this.workPackage.lockVersion = res.lockVersion
              this.signloding = null
              this.changeDetectorRef.markForCheck();
              this.changeDetectorRef.detectChanges();
              //console.log('wokerpage都掉这里的接口吗');
              this.handlerCheck.eventBus.emit('showDialog')
          })
        })
      // })
    })
    this.groupimgdata[this.group.members[this.groupitem].name] = img     
  }

  dataURLtoBlob(dataurl:any) {
    var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  }

  urlsubscribe(){
    
  }

  checkDefaultSignChange(name:any) {
    if(this.isDefoultSign) {
      this.http.post(
        `/api/v3/work_packages/${this.workPackage.id}/custom_fields/set_defauls_sign`,
        {
          custom_sign_field_name: name,
          custom_sign_field_default_value: this.currentUser.dataset.sign_doc_id
        },
        {
          withCredentials: true,
          headers: this.requestHeader
        }
      ).subscribe( (res) => {
   
      })
    } else {
      this.http.post(
        `/api/v3/work_packages/${this.workPackage.id}/custom_fields/set_defauls_sign`,
        {
          custom_sign_field_name: name,
          custom_sign_field_default_value: ''
        },
        {
          withCredentials: true,
          headers: this.requestHeader
        }
      ).subscribe( (res) => {
    
      })
    }
  }

  userquanx(name:any, type?:any){
    // if(this.okselect) return false
    let signdata:any = this.group
    // //console.log(signdata,'signdata')
    if(this.is_project_admin && type == 'Inspection') {
      return false
    }
    if(!this.group.status.find( (item:any) => {
      return item.id == this.workPackage.status.id
    }) ) {
      if(this.is_project_admin && type == 'Inspection') {
     
      } else {

        return true
      }
    }
    if(this.customFieldGroupPrincipal.length == 0) return true
    if(!signdata.sign.real_principal_name){
      let index = this.customFieldGroupPrincipal.find((res:any)=>{
        return `${res.lastname} ${res.firstname}` == signdata.sign.principal_name || (!signdata.sign.principal_name&&this.workPackage.author.id ==this.currentUser.dataset.id)
      })
      if(!index) return true
      return index.mail != this.currentUser.dataset.mail
    }else{
      let index = this.customFieldGroupPrincipal.find((res:any)=>{
        return `${res.lastname} ${res.firstname}` == signdata.sign.real_principal_name
      })
      if(!index) return true
      return index.mail != this.currentUser.dataset.mail 
    }

  }

  //下拉框下面的文字
  dipssignuser(name:any){
    let signdata:any = this.group
    if(signdata.sign.real_principal_name && signdata.sign.principal_name) return ''
    let index = this.customFieldGroupPrincipal.find((res:any)=>{
      return `${res.lastname} ${res.firstname}` == signdata.sign.principal_name || `${res.lastname} ${res.firstname}` == signdata.sign.real_principal_name
    })
    if(!index)return `${signdata.sign.principal_name}`
    let position = index.position?`[${index.position}]` : ''
    return signdata.sign.real_principal_name? `${position}${signdata.sign.real_principal_name}` : `${position}${signdata.sign.principal_name}`
    // if(signdata.sign.type == 'User'){

    // }else{
    //   return signdata.sign.real_principal_name? signdata.sign.real_principal_name :`Please assign to a specific User instead of a User Group for signature purpose.`
    // }
    // if(this.signusername) {
    //   let username = this.signusername.sign_custom_fields.find((res:any)=>{
    //     return 'customField'+res.id == name
    //   })
    //   return username.responsible.name
    // }

  }


  get_custom_field_group_available_principal(element:any){
      this.http.get(`/api/v3/work_packages/${this.workPackage.id}/custom_field_group_available_principal?custom_field_group_name=${element}`).subscribe((res:any)=>{
        this.customFieldGroupPrincipal= res.principals
        let panduan = true
        let elementpadnuan = true
        let name = ''

         
          res.principals.forEach((element:any, i:any) => {
            if(i == 0){
              if(element.lastname || element.firstname) {

                name = element.lastname + element.firstname
              } else {
                name += element.name 
              }
            } else {
              if(element.lastname || element.firstname) {

                name = name + ','+ element.lastname + element.firstname
              } else {
                name += ',' + element.name 
              }
            }
          });
        
        for(let i = res.principals.length -1 ; i>=0 ; i--) {
          if(res.principals[i].hasOwnProperty('users')) {
            let users: Array<any> =  res.principals[i].users
       
            res.principals.splice(i + 1,0, ...users)
          }
        }
        res.principals.forEach((prinres:any, i: any) => {
          
          if(panduan){
            if(this.group.real_principal_name == `${prinres.lastname} ${prinres.firstname}` ||  (this.group.real_principal_name == `${prinres.lastname} ${prinres.firstname}`.trim() || this.group.real_principal_name == prinres.name) ){
              this.selectCustomFieldGroup = prinres.id
              panduan = false
            } 
            if(!this.group.real_principal_name && (this.group.principal_name == `${prinres.lastname} ${prinres.firstname}` ||  (this.group.principal_name == `${prinres.lastname} ${prinres.firstname}`.trim() || this.group.principal_name == prinres.name)) ) {
              this.selectCustomFieldGroup = prinres.id
              panduan = false
            }
            // else if(element !== 'FOR Contractor: Submission detail'){
            //   if(elementpadnuan){
            //     this.selectCustomFieldGroup = null
            //     //每一个子分类的选项
            //     this.customFieldGroupPrincipal.unshift({id:null,login:this.group.principal_name})
            //     elementpadnuan = false
            //   }
              
            // }
          }
        });
        if(panduan){
          
   
          res.principals.unshift({
            id:null,
            login: name
          })
        }
      })
  }
  selectName(item:any){
    //console.log(item,'abddd');
    
    if(item.id){
      //item 中有id的是人，需要添加职位
      let position = item.position? '['+item.position+']' : ''
      if(item.firstname || item.lastname) {

        return `${item.lastname} ${item.firstname} ${position}`
      } else{
        return `${item.name} ${position} `
      }
    }else{
      //没有id的是组
      return item.login
    }
    
  }

  //签名错误
  userzhuPlease(){
    let signdata:any = this.group
    const currentUser: any = document.querySelector('meta[name=current_user]');
    if(signdata.sign.real_principal_name){
      let index = this.customFieldGroupPrincipal.find((res:any)=>{
        return `${res.lastname} ${res.firstname}` == signdata.sign.real_principal_name
      })
      if(!index) return true
      return false
    }else{
      return false
    }
    
  }
  Tip() {
    let check = false
    let checkGround = this.groupedFields.find( (item:any) => {
      return item.name == 'Inspection detail'
    }).members
    checkGround.forEach( (res:any) => {
      if(res.field.value == true){
        check = true
      }
    })
      return (this.group.name ==='Form returned and signed by RE/IOW/SSOE') &&  !check
  }

  //handler下拉框选项改变，重新刷新一次页面
  changesCustomFieldGroup(){
    let customField = this.customFieldGroupPrincipal.find( (item:any) => {
   
      return item.id == Number(this.selectCustomFieldGroup)
    })
    let file = {custom_field_group_name:this.group.name,principal_id:this.selectCustomFieldGroup} as any
    if(customField.type) {
      file.principal_type =  customField.type
    }
    this.requefunckpatch(file,`${this.apiPrefix}/work_packages/${this.workPackage.id}/change_custom_field_group_principal`).subscribe((res:any)=>{
      if(res == 200){
        this.http.post(
          `/api/v3/work_packages/${this.workPackage.id}/custom_fields/set_defauls_sign`,
          {
            custom_sign_field_name: name,
            custom_sign_field_default_value: ''
          },
          {
            withCredentials: true,
            headers: this.requestHeader
          }
        ).subscribe( (res) => {
      
          this.handlerCheck.eventBus.emit('handleChange')
        })
      }
    })
  }

  requefunckpatch(data: any,url:any){
    return this.http.patch(
      url,
      data,
      {
        withCredentials: true,
        headers: this.requestHeader
      }
    );
  }

  requefunckpost(data: any,url:any){
    return this.http.post(
      url,
      data,
      {
        withCredentials: true,
        headers: this.requestHeader
      }
    );
  }

  requefunckget(url:any){
    return this.http.get(
      url,
      {}
    );
  }

  // 添加通知示例方法
  showSuccessNotification(message: string) {
    this.notificationsService.addSuccess(message);
  }

  showErrorNotification(message: string, errors: string[] = []) {
    this.notificationsService.addError(message, errors);
  }

  showInfoNotification(message: string) {
    this.notificationsService.addNotice(message);
  }

  // 新增属性
  public editSignTime: any = {};
  public editSignTimeValue: any = {};

  // 开始编辑签名时间
  startEditSignTime(descriptor: any) {
    this.editSignTime[descriptor.name] = true;
    const timeStr = this.groupimgdata[descriptor.name + '_time'];
    if (timeStr) {
      // 保留秒： "2026-06-22 17:49:37" → "2026-06-22T17:49:37"
      this.editSignTimeValue[descriptor.name] = timeStr.replace(' ', 'T');
    }
  }

  // 保存签名时间
  saveSignTime(descriptor: any) {
    const timeValue = this.editSignTimeValue[descriptor.name];
    if (!timeValue) return;
    // datetime-local 返回 "2026-06-22T17:49:37"，转为 "2026-06-22 17:49:37"
    const formattedTime = timeValue.replace('T', ' ');
    this.http.put(`/api/v3/work_packages/change_sign_time`, {
      id: this.workPackage.id,
      field_name: descriptor.label,
      sign_time: formattedTime
    }, {
      withCredentials: true,
      headers: this.requestHeader
    }).subscribe((res: any) => {
      this.groupimgdata[descriptor.name + '_time'] = formattedTime;
      this.editSignTime[descriptor.name] = false;
    });
  }

  // 取消编辑
  cancelEditSignTime(descriptor: any) {
    this.editSignTime[descriptor.name] = false;
  }

}
